import CalendarView from './CalendarPage/CalendarView';
import EventsView from './EventsPage/EventsView';
import MetricView from './MetricPage/MetricView';
import PlanViewHeader from './PlanViewHeader';
import { usePlanDetailsContext } from './context/PlanDetailsContext';

const PlannerTab = ({ planDetails }: { planDetails: { planId: string; planName: string } }) => {
    const { planId, planName } = planDetails;
    const { activeView } = usePlanDetailsContext();

    return (
        <div>
            {activeView !== 'event' && <PlanViewHeader planId={planId} planName={planName ?? ''} />}
            {activeView === 'calendar' && <CalendarView planId={planId} planName={planName ?? ''} />}
            {activeView === 'metric-view' && <MetricView planId={planId} planName={planName ?? ''} />}
            {activeView === 'event' && <EventsView planId={planId} />}
        </div>
    );
};

export default PlannerTab;
